export default `
    <section id="#= data.id #" class="#= data.classes #">
        <section id="HamburgerMenu" class="container hamburger" style="width:0px;"></section>
        <section id="TopToolbar" class="container banner-class">
            <div id="#= data.id #_Toolbar" class="top-toolbar">
                #= data.topToolbar #
            </div>
        </section>
        <section id="Main">
            <div id="AutoSaveContainer"></div>
            <div id="Loader" class="progress progress-striped active loading-bar">
                <span class="loading-bar-message">Loading...</span>
                <div class="progress-bar" role="progressbar" style="width: 100%">
                </div>
            </div>
            <div class="sp-logo-gray-tagline"></div>
            <section id="#= data.id #_Content">
                <section class="left-column">
                    #= data.leftColumn #
                </section>
                <section class="left-column-menu"></section>
                <section class="workspace container">
                    #= data.workspace #
                </section>
                <section class="full-workspace container"></section>
                <section class="sub-workspace">
                    #= data.subWorkspace #
                </section>
            </section>
        </section>
    </section>
`;
